import useSocialAuthLocale from "@casino/legacy/client/features/SocialAuth/hooks/useSocialAuthLocale";
import Translate from "@casino/legacy/client/shared/i18n/Translate";
import KeylineText from "@casino/legacyUi/KeylineText";

const SocialsKeyLineText: FC = () => {
  const [, setLocale] = useSocialAuthLocale();
  setLocale();

  return (
    <KeylineText>
      <Translate
        className="text-muted-foreground uppercase text-[10px] tracking-[1px]"
        id="general.or"
      />
    </KeylineText>
  );
};

export default SocialsKeyLineText;
